import React from 'react';
import {Row, Col,Button,Modal} from "react-bootstrap"
import { BiPaperPlane, BiCloudDownload } from "react-icons/bi";
import { useTranslation } from 'react-i18next';


interface ModalProps {
  showModal: boolean;
  closeModal: () => void;
  children: (props?: any) => React.ReactNode; // <-- support render function
  childProps: any,
  onSave: () => void,
  onDownload: () =>void,
}

const DocumentModal: React.FC<ModalProps> = ({
  showModal,
  closeModal,
  children,
  childProps,
  onSave,
  onDownload

}) => {
  const { t } = useTranslation();  

  return (
    <div>
      <Modal show={showModal} onHide={closeModal} size="lg" centered>
          <Modal.Body>
            { children(childProps) }
          </Modal.Body>
          <hr className="mt-4 mb-3" />
          <div className="pb-4 px-4">
              <Row>
                <Col md={6}>
                  <Button variant="primary" className="d-block w-100" onClick={onSave}>
                    <BiPaperPlane style={{ width: '15px', height: '15px', marginTop: '-3px' }} className="me-2" />{t('save')}
                  </Button>
                </Col>
                <Col md={6}>
                  <Button variant="outline-primary" className="d-block w-100 mt-3 mt-md-0" onClick={onDownload}>
                    <BiCloudDownload style={{ width: '16px', height: '16px', marginTop: '-3px' }} className="me-2" />
                    {t('downloadCopy')}
                  </Button>
                </Col>
              </Row>
            </div>
      </Modal>
     
    </div>
  );
}

export default DocumentModal;
